<p-accordionTab>
    <p-header>
        <div class="ui-helper-clearfix">
            <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Bearer Settings
                    (AT+GTBSI)</span>
            </div>
        </div>
    </p-header>

    <div class="row align-items-center">

        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Main APN">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.mainApn" maxlength="40" class="txtbStyle"/>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Main APN User Name">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.mainApnUsername" maxlength="30" class="txtbStyle"/>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        


        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Main APN Password">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.mainApnPassword" maxlength="30" class="txtbStyle"/>
                </div>
            </div>
        </div>
    
    </div>

    <div class="row align-items-center">

        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Backup APN">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.backupApn" maxlength="40" class="txtbStyle"/>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
    
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Backup APN User Name">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.backupApnUsername" maxlength="30" class="txtbStyle"/>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Backup APN Password">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]="bsiParameters.backupApnPassword" maxlength="30" class="txtbStyle"/>
                </div>
            </div>
        </div>  
    </div>

    <div class="row align-items-center">

        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Network Mode">
                </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="networkOptions" [(ngModel)]="bsiParameters.networkMode"
                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="APN Authentication Methods">
                </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="authenticationOptions" [(ngModel)]="bsiParameters.authenticationMethods"
                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
            </div>
        </div>
    
    </div>

    <div class="row align-items-center">

        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="LTE Mode">
                </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="lteOptions" [(ngModel)]="bsiParameters.lteMode"
                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Manual Netreg">
                </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="netregOptions" [(ngModel)]="bsiParameters.manualNetreg"
                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
            </div>
        </div>
    
    </div>

    
</p-accordionTab>